import { CompletedWorkout } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useCompleteWorkout = (): UseMutationResult<CompletedWorkout, Error, { workoutId: string }> => {
  const queryClient = useQueryClient()

  return useMutation<CompletedWorkout, Error, { workoutId: string }>(
    ({ workoutId }) => coreService.completeWorkout({ workoutId }),
    {
      onSuccess: (_, { workoutId }) => {
        queryClient.invalidateQueries(queryKeys.completedWorkouts())
        queryClient.invalidateQueries(queryKeys.completedWorkouts({ workoutIds: [workoutId] }))
      },
    },
  )
}
